import { DashboardLayout } from '@/backoffice/components/layout';
import { Card } from '@/backoffice/components/ui';
import { useBackofficeRole } from '@/backoffice/hooks/useBackofficeRole';
import { HelpCircle, Mail, MessageCircle, Phone } from 'lucide-react';

const FAQ = [
  { q: 'Comment contacter le support ?', a: 'Utilisez la messagerie support depuis votre espace ou écrivez à support@onapila.com.' },
  { q: 'Comment modifier ma localisation ?', a: 'Rendez-vous dans Mon profil et sélectionnez votre pays, région, préfecture, commune, quartier et secteur.' },
  { q: 'Comment recharger mon portefeuille ?', a: 'Accédez à Portefeuille, choisissez un opérateur (Orange Money, MTN MoMo) et validez le montant.' },
];

export function SharedHelpPage() {
  const userType = useBackofficeRole();

  return (
    <DashboardLayout userType={userType} title="Aide">
      <div className="grid lg:grid-cols-3 gap-6 max-w-5xl">
        <Card className="text-center">
          <Phone className="w-8 h-8 text-indigo-600 mx-auto mb-3" />
          <p className="font-semibold">Téléphone</p>
          <p className="text-sm text-gray-500 mt-1">+224 620 00 00 00</p>
        </Card>
        <Card className="text-center">
          <Mail className="w-8 h-8 text-indigo-600 mx-auto mb-3" />
          <p className="font-semibold">Email</p>
          <p className="text-sm text-gray-500 mt-1">support@onapila.com</p>
        </Card>
        <Card className="text-center">
          <MessageCircle className="w-8 h-8 text-indigo-600 mx-auto mb-3" />
          <p className="font-semibold">Chat</p>
          <p className="text-sm text-gray-500 mt-1">Lun–Sam 8h–20h</p>
        </Card>
      </div>

      <Card className="mt-6 max-w-3xl">
        <h3 className="font-semibold flex items-center gap-2 mb-4"><HelpCircle className="w-5 h-5" /> Questions fréquentes</h3>
        <div className="space-y-4">
          {FAQ.map((item) => (
            <div key={item.q} className="border-b border-gray-100 pb-4 last:border-0">
              <p className="font-medium text-gray-900">{item.q}</p>
              <p className="text-sm text-gray-600 mt-1">{item.a}</p>
            </div>
          ))}
        </div>
      </Card>
    </DashboardLayout>
  );
}
